import {
    ICancelReasonItem,
    IOrderDetails,
    IOrderHistoryLine,
    IOrderHistoryRequest,
    IOrderHistoryResult,
    IRelatedItems,
    IUpdateOptionData,
} from '../../models/order';
import { IITAPISResult, IResult } from '../../models/result-models';
import {
    LOAD_ORDER_ERROR,
    LOAD_ORDER_SUCCESS,
    LOAD_ORDERS_ERROR,
    LOAD_ORDERS_SUCCESS,
    REORDER_ERROR,
    REORDER_SUCCESS,
    CANCEL_REASONS_SUCCESS,
    CANCEL_REASONS_ERROR,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_ERROR,
    UPDATE_SHIPTO_SUCCESS,
    UPDATE_SHIPTO_ERROR,
    UPDATE_DELIVERTO_SUCCESS,
    UPDATE_DELIVERTO_ERROR,
    CLEAR_DELIVERTO,
    UPDATE_BILLTO_SUCCESS,
    UPDATE_BILLTO_ERROR,
    DELETE_LINEITEM_SUCCESS,
    DELETE_LINEITEM_ERROR,
    GET_RELATED_ITEMS_SUCCESS,
    GET_RELATED_ITEMS_ERROR,
    CLEAR_RELATED_ITEMS,
    ADD_ITEMS_SUCCESS,
    ADD_ITEMS_ERROR,
    CLEAR_ADD_ITEMS,
    POST_ESCALATION_SUCCESS,
    POST_ESCALATION_ERROR,
    RESET_ESCALATION_STATUS,
    LINE_ITEM_PT_TRUE,
    LINE_ITEM_PT_FALSE,
    CLEAR_REORDER,
    UPDATE_OPTION_DATA,
    CLEAR_OPTION_DATA,
    ADJUST_FEATURES_SUCCESS,
    ADJUST_FEATURES_ERROR,
    UPDATE_SELECT,
    CLEAR_ADJUST_FEATURES,
    ORDER_HISTORY_REQUEST,
} from './order-actions';

interface LoadOrderSuccessAction {
    type: 'LOAD_ORDER_SUCCESS';
    result: IResult<IOrderDetails>;
}

interface LoadOrderErrorAction {
    type: 'LOAD_ORDER_ERROR';
    result: any;
}

interface LoadOrdersSuccessAction {
    type: 'LOAD_ORDERS_SUCCESS';
    result: IResult<IOrderHistoryResult>;
}

interface LoadOrdersErrorAction {
    type: 'LOAD_ORDERS_ERROR';
    result: any;
}

interface ReorderSuccessAction {
    type: 'REORDER_SUCCESS';
    result: IResult<boolean>;
}

interface ReorderErrorAction {
    type: 'REORDER_ERROR';
    result: any;
}

interface ReorderClearAction {
    type: 'CLEAR_REORDER';
    result: any;
}
interface CancelOrderSuccessAction {
    type: 'CANCEL_ORDER_SUCCESS';
    result: IResult<IITAPISResult>;
}
interface CancelOrderErrorAction {
    type: 'CANCEL_ORDER_ERROR';
    result: IResult<IITAPISResult>;
}

interface CancelReasonsSuccessAction {
    type: 'CANCEL_REASONS_SUCCESS';
    result: IResult<ICancelReasonItem[]>;
}
interface CancelReasonsErrorAction {
    type: 'CANCEL_REASONS_ERROR';
    result: any;
}
interface UpdateShipToSuccessAction {
    type: 'UPDATE_SHIPTO_SUCCESS';
    result: IResult<boolean>;
}

interface UpdateShipToErrorAction {
    type: 'UPDATE_SHIPTO_ERROR';
    result: any;
}
interface UpdateDeliverToSuccessAction {
    type: 'UPDATE_DELIVERTO_SUCCESS';
    result: IResult<IITAPISResult>;
}

interface UpdateDeliverToErrorAction {
    type: 'UPDATE_DELIVERTO_ERROR';
    result: any;
}
interface UpdateDeliverToClearAction {
    type: 'CLEAR_DELIVERTO';
}

interface UpdateBillToSuccessAction {
    type: 'UPDATE_BILLTO_SUCCESS';
    result: IResult<boolean>;
}

interface UpdateBillToErrorAction {
    type: 'UPDATE_BILLTO_ERROR';
    result: any;
}

interface DeleteLineItemSuccessAction {
    type: 'DELETE_LINEITEM_SUCCESS';
    result: IResult<IITAPISResult>;
}

interface DeleteLineItemErrorAction {
    type: 'DELETE_LINEITEM_ERROR';
    result: any;
}

interface GetRelatedItemsSuccessAction {
    type: 'GET_RELATED_ITEMS_SUCCESS';
    result: IResult<IRelatedItems>;
}

interface GetRelatedItemsErrorAction {
    type: 'GET_RELATED_ITEMS_ERROR';
    result: any;
}
interface ClearRelatedItemsAction {
    type: 'CLEAR_RELATED_ITEMS';
    result: null;
}

interface AddItemsSuccessAction {
    type: 'ADD_ITEMS_SUCCESS';
    result: IResult<IITAPISResult>;
}

interface AddItemsErrorAction {
    type: 'ADD_ITEMS_ERROR';
    result: any;
}
interface AddItemsClearAction {
    type: 'CLEAR_ADD_ITEMS';
    result: any;
}
interface PostEscalationSuccessAction {
    type: 'POST_ESCALATION_SUCCESS';
    result: IResult<string>;
}
interface PostEscalationErrorAction {
    type: 'POST_ESCALATION_ERROR';
    result: IResult<string>;
}
interface ResetEscalationStatus {
    type: 'RESET_ESCALATION_STATUS';
}
interface LineitemPTTrue {
    type: 'LINE_ITEM_PT_TRUE';
}
interface LineitemPTFalse {
    type: 'LINE_ITEM_PT_FALSE';
}
interface UpdateOptionData {
    type: 'UPDATE_OPTION_DATA';
    result: IUpdateOptionData;
}
interface ClearOptionData {
    type: 'CLEAR_OPTION_DATA';
}
interface AdjustFeaturesSuccessAction {
    type: 'ADJUST_FEATURES_SUCCESS';
    result: IResult<IITAPISResult>;
}

interface AdjustFeaturesErrorAction {
    type: 'ADJUST_FEATURES_ERROR';
    result: IResult<IITAPISResult>;
}
type UpdateSelect = {
    type: 'UPDATE_SELECT';
    result: number;
};
type ClearAdjustFeatures = {
    type: 'CLEAR_ADJUST_FEATURES';
};
type OrderHistoryRequest = {
    type: 'ORDER_HISTORY_REQUEST';
    result: IOrderHistoryRequest;
};

type OrderKnownAction = LoadOrderSuccessAction | LoadOrderErrorAction;
type CancelOrderKnownAction = CancelOrderSuccessAction | CancelOrderErrorAction;
type OrdersKnownAction = LoadOrdersSuccessAction | LoadOrdersErrorAction;
type ReorderKnownAction =
    | ReorderSuccessAction
    | ReorderErrorAction
    | ReorderClearAction;
type CancelReasonsKnownAction =
    | CancelReasonsSuccessAction
    | CancelReasonsErrorAction;
type UpdateShipToKnownAction =
    | UpdateShipToSuccessAction
    | UpdateShipToErrorAction;
type UpdateDeliverToKnownAction =
    | UpdateDeliverToSuccessAction
    | UpdateDeliverToErrorAction
    | UpdateDeliverToClearAction;
type UpdateBillToKnownAction =
    | UpdateBillToSuccessAction
    | UpdateBillToErrorAction;
type DeleteLineKnownAction =
    | DeleteLineItemSuccessAction
    | DeleteLineItemErrorAction;
type GetRelatedItemsKnownAction =
    | GetRelatedItemsSuccessAction
    | GetRelatedItemsErrorAction
    | ClearRelatedItemsAction;
type AddItemsKnownAction =
    | AddItemsSuccessAction
    | AddItemsErrorAction
    | AddItemsClearAction;
type PostEscalationKnownAction =
    | PostEscalationSuccessAction
    | PostEscalationErrorAction
    | ResetEscalationStatus;
type LineItemPizzaTrackerKnownAction = LineitemPTTrue | LineitemPTFalse;
type UpdateOptionDataKnownAction = UpdateOptionData | ClearOptionData;
type AdjustFeaturesKnownAction =
    | AdjustFeaturesSuccessAction
    | AdjustFeaturesErrorAction
    | ClearAdjustFeatures;
type OrderHistoryRequestKnownAction = OrderHistoryRequest;
export const orderReducer = (
    state: IResult<IOrderDetails> | null | undefined = null,
    action: OrderKnownAction
) => {
    switch (action.type) {
        case LOAD_ORDER_SUCCESS:
            return action.result;
        case LOAD_ORDER_ERROR: {
            const result: IResult<IOrderDetails> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};

export const ordersReducer = (
    state: IResult<IOrderHistoryResult> | null | undefined = null,
    action: OrdersKnownAction
) => {
    switch (action.type) {
        case LOAD_ORDERS_SUCCESS:
            return action.result;
        case LOAD_ORDERS_ERROR: {
            const result: IResult<IOrderHistoryResult> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};

export const reorderReducer = (
    state: IResult<boolean> | null | undefined = null,
    action: ReorderKnownAction
) => {
    switch (action.type) {
        case REORDER_SUCCESS:
            return action.result;
        case REORDER_ERROR: {
            const result: IResult<boolean> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        case CLEAR_REORDER:
            return null;
        default:
            return state;
    }
};
export const cancelOrderReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: CancelOrderKnownAction
) => {
    switch (action.type) {
        case CANCEL_ORDER_SUCCESS:
            return action.result;
        case CANCEL_ORDER_ERROR:
            return action.result;
        default:
            return state;
    }
};

export const cancelReasonsReducer = (
    state: IResult<ICancelReasonItem[]> | null | undefined = null,
    action: CancelReasonsKnownAction
) => {
    switch (action.type) {
        case CANCEL_REASONS_SUCCESS:
            return action.result;
        case CANCEL_REASONS_ERROR: {
            const result: IResult<ICancelReasonItem[]> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};
export const updateShipToReducer = (
    state: IResult<boolean> | null | undefined = null,
    action: UpdateShipToKnownAction
) => {
    switch (action.type) {
        case UPDATE_SHIPTO_SUCCESS:
            return action.result;
        case UPDATE_SHIPTO_ERROR: {
            const result: IResult<boolean> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};
export const updateDeliverToReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: UpdateDeliverToKnownAction
) => {
    switch (action.type) {
        case UPDATE_DELIVERTO_SUCCESS:
            return action.result;
        case UPDATE_DELIVERTO_ERROR:
            return action.result;
        case CLEAR_DELIVERTO:
            return null;
        default:
            return state;
    }
};

export const updateBillToReducer = (
    state: IResult<boolean> | null | undefined = null,
    action: UpdateBillToKnownAction
) => {
    switch (action.type) {
        case UPDATE_BILLTO_SUCCESS:
            return action.result;
        case UPDATE_BILLTO_ERROR: {
            const result: IResult<boolean> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};

export const deleteLineItemReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: DeleteLineKnownAction
) => {
    switch (action.type) {
        case DELETE_LINEITEM_SUCCESS:
            return action.result;
        case DELETE_LINEITEM_ERROR:
            return action.result;
        default:
            return state;
    }
};

export const relatedItemsReducer = (
    state: IResult<IRelatedItems> | null | undefined = null,
    action: GetRelatedItemsKnownAction
) => {
    switch (action.type) {
        case GET_RELATED_ITEMS_SUCCESS:
            return action.result;
        case GET_RELATED_ITEMS_ERROR:
            return action.result;
        case CLEAR_RELATED_ITEMS:
            return null;
        default:
            return state;
    }
};

export const addItemsReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: AddItemsKnownAction
) => {
    switch (action.type) {
        case ADD_ITEMS_SUCCESS:
            return action.result;
        case ADD_ITEMS_ERROR:
            return action.result;
        case CLEAR_ADD_ITEMS:
            return null;
        default:
            return state;
    }
};
export const postEscalationReducer = (
    state: IResult<string> | null | undefined = null,
    action: PostEscalationKnownAction
) => {
    switch (action.type) {
        case POST_ESCALATION_SUCCESS:
            return action.result;
        case POST_ESCALATION_ERROR:
            return action.result;
        case RESET_ESCALATION_STATUS:
            return null;
        default:
            return state;
    }
};
export const lineItemPizzaTrackerReducer = (
    state: boolean | undefined = false,
    action: LineItemPizzaTrackerKnownAction
) => {
    switch (action.type) {
        case LINE_ITEM_PT_TRUE:
            return true;
        case LINE_ITEM_PT_FALSE:
            return false;
        default:
            return state;
    }
};

export const updateOptionDataReducer = (
    state: IUpdateOptionData | null | undefined = null,
    action: UpdateOptionDataKnownAction
) => {
    switch (action.type) {
        case UPDATE_OPTION_DATA:
            return action.result;
        case CLEAR_OPTION_DATA:
            return null;
        default:
            return state;
    }
};
export const adjustFeaturesReducer = (
    state: IResult<IITAPISResult> | null | undefined = null,
    action: AdjustFeaturesKnownAction
) => {
    switch (action.type) {
        case ADJUST_FEATURES_SUCCESS:
            return action.result;
        case ADJUST_FEATURES_ERROR:
            return action.result;
        case CLEAR_ADJUST_FEATURES:
            return null;
        default:
            return state;
    }
};
export const selectReducer = (
    state: null | undefined = null,
    action: UpdateSelect
) => {
    switch (action.type) {
        case UPDATE_SELECT:
            return action.result;
        default:
            return state;
    }
};
export const orderHistoryRequestReducer = (
    state: null | undefined = null,
    action: OrderHistoryRequestKnownAction
) => {
    switch (action.type) {
        case ORDER_HISTORY_REQUEST:
            return action.result;
        default:
            return state;
    }
};
